"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SINGLETON_DEF = Symbol('singleton-def');
const DISCARDABLE_DEF = Symbol('discardable-def');
const CUSTOM_DEF = Symbol('custom-def');
const POST_CONSTRUCTOR_ACCESSOR = Symbol('post-contructor-accessor');
const EAGER_ACCESSOR = Symbol('eager-accessor');
class Secrets {
    static setSingleton(definition) {
        definition[SINGLETON_DEF] = true;
    }
    static isSingleton(definition) {
        return definition[SINGLETON_DEF] === true;
    }
    static setDiscardable(definition) {
        definition[DISCARDABLE_DEF] = true;
    }
    static isDiscardable(definition) {
        return definition[DISCARDABLE_DEF] === true;
    }
    static setCustom(definition) {
        definition[CUSTOM_DEF] = true;
    }
    static isCustom(definition) {
        return definition[CUSTOM_DEF] === true;
    }
    static setPostContruct(definition, name) {
        definition[POST_CONSTRUCTOR_ACCESSOR] = name;
    }
    static getPostContruct(definition) {
        return definition[POST_CONSTRUCTOR_ACCESSOR];
    }
    static setEager(definition, name) {
        definition[EAGER_ACCESSOR] = definition[EAGER_ACCESSOR] || [];
        definition[EAGER_ACCESSOR].push(name);
    }
    static getEagers(definition) {
        return definition[EAGER_ACCESSOR] || [];
    }
}
exports.default = Secrets;
//# sourceMappingURL=Secrets.js.map